"use client";

import React from "react";

import { cn } from "@/lib/utils";
import { PortableText } from "@portabletext/react";
import { richTextComponent } from "@/sanity/sanityPortableText";
import { PortableTextBlock } from "sanity";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/shadcn/ui/accordion";

export default function FAQListNew({
  faq,
  className = "",
}: {
  faq: {
    question: string;
    answer: PortableTextBlock[];
  }[];
  className?: string;
}) {
  if (!faq || faq.length === 0) return null;

  return (
    <Accordion
      type="single"
      collapsible
      className={cn("relative w-full flex flex-col", className)}
    >
      {faq.map((item, index) => (
        <div key={index} className="flex flex-col">
          <AccordionItem
            key={index}
            value={`item-${index + 1}`}
            className="group p-[2.25rem] sm:p-[4rem] relative prose-h3:m-0 rounded-[1.5rem] data-[state=open]:bg-[#F6F9F7] transition-colors duration-300 ease-in-out"
          >
            <AccordionTrigger className="py-0 [&_.accordionTriggerIconBg]:bg-[#90C89E] [&_.accordionTriggerIconBg]:w-[4.93rem] [&_.accordionTriggerIconBg]:h-[4.875rem]">
              <h3 className="mb-0 font-geist font-normal text-[#103037] text-start text-[2.5rem] tracking-normal">
                {item?.question}
              </h3>
            </AccordionTrigger>

            <AccordionContent className="pb-0 pl-[5.5rem] sm:pl-[6rem] pt-[1rem] richtext richtext-start prose-headings:!text-[2.25rem] prose-headings:!mt-[2.5rem] prose-headings:!mb-[.5rem] prose-strong:text-black/90 prose-strong:font-medium prose-p:mb-[1.5rem] prose-ul:mb-[1.5rem] prose-ul:pl-[2rem] prose-li:m-0 prose-li:p-0 prose-ul:flex prose-ul:flex-col prose-ul:gap-[.5rem]">
              <PortableText
                value={item?.answer}
                components={richTextComponent}
              />
            </AccordionContent>

            <hr
              className={cn(
                "translate-y-[1px] opacity-10 group-data-[state=open]:!opacity-0 transition-opacity duration-300 ease-in-out absolute bottom-0 left-1/2 -translate-x-1/2 border-t [border-image:repeating-linear-gradient(to_right,rgba(0,0,0,1)_0,rgba(0,0,0,1)_10px,transparent_10px,transparent_20px)_1] w-[calc(100%-2rem)]",
                faq.length > index + 1 ? "block" : "hidden",
              )}
            />
          </AccordionItem>
        </div>
      ))}
    </Accordion>
  );
}
